export default (newSections, oldState) => {
	const newSectionIds = newSections.map(({id}) => id);
	let newState = newSections;
	if (oldState !== null) newState = [...newSections, ...oldState.filter(({id}) => !newSectionIds.includes(id))];
	return newState;
};
